var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"type":"button"}},[_vm._v(_vm._s(_vm.txt))])
}
var staticRenderFns = []

export { render, staticRenderFns }